// extracted by mini-css-extract-plugin
export default {"canvas":"Dragon_canvas__S0Mmp"};